import React, { useState, useMemo, useEffect } from "react";
import {
    Typography,
    Card,
    CardContent,
    Grid,
    Button,
    TextField,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box,
    Paper
} from "@mui/material";
import { Search } from "@mui/icons-material";
import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from "react-router-dom";
import ModalNotificacao from "./ModalNotificacao";
import axios from "axios";
import HomeIcon from '@mui/icons-material/Home';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
// import ModalNotificacao from "./ModalNotificacao";
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import { Breadcrumbs, Link } from "@mui/material";
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import DownloadIcon from '@mui/icons-material/Download';
import CachedIcon from '@mui/icons-material/Cached';

const statusMap = {
    PENDING: { label: "Pendente", colorBg: "#fff8e1", colorText: "#f9a825" },
    RECEIVED: { label: "Pago", colorBg: "#e8f5e9", colorText: "#2e7d32" },
    RECEIVED_IN_CASH: { label: "Pago", colorBg: "#e8f5e9", colorText: "#2e7d32" },
    CONFIRMED: { label: "Pago", colorBg: "#e8f5e9", colorText: "#2e7d32" },
    OVERDUE: { label: "Vencida", colorBg: "#ffebee", colorText: "#c62828" },
    DUNNING_REQUESTED: { label: "Vencida", colorBg: "#ffebee", colorText: "#c62828" },
    DUNNING_RECEIVED: { label: "Vencida", colorBg: "#ffebee", colorText: "#c62828" },
    REFUNDED: { label: "Reembolsada", colorBg: "#e1f5fe", colorText: "#0277bd" },
    REFUND_REQUESTED: { label: "Reembolso solicitado", colorBg: "#e1f5fe", colorText: "#0277bd" },
    REFUND_IN_PROGRESS: { label: "Reembolso em progresso", colorBg: "#e1f5fe", colorText: "#0277bd" },
    CHARGEBACK_REQUESTED: { label: "Chargeback", colorBg: "#fce4ec", colorText: "#c2185b" },
    CHARGEBACK_DISPUTE: { label: "Chargeback", colorBg: "#fce4ec", colorText: "#c2185b" },
    AWAITING_CHARGEBACK_REVERSAL: { label: "Chargeback", colorBg: "#fce4ec", colorText: "#c2185b" },
    AWAITING_RISK_ANALYSIS: { label: "Análise de risco", colorBg: "#fff3e0", colorText: "#ef6c00" },
    // Outros status podem ser adicionados aqui conforme necessário
};


const FaturasPagas = () => {
    const { user } = useUser();
    const navigate = useNavigate();

    const [busca, setBusca] = useState("");
    const [statusFiltro, setStatusFiltro] = useState("todos");
    const [faturas, setFaturas] = useState([]);
    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);

    useEffect(() => {
        // Verifica se o usuário está com fatura vencida
        const hasFaturasVencidas = user?.faturas?.vencidas?.length > 0;

        if (hasFaturasVencidas) {
            setUserActive(false);
        } else {
            setUserActive(true);
        }
    }, [user]);

    useEffect(() => {
        const getNotify = async () => {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/buscarNotificacoes`, { email: localStorage.getItem("email") }, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });

            if (response.data.status === 200) {
                setNotificacoes(response.data.notificacoes)
            }
        }

        getNotify();
    }, [])


    function formatarDataBR(dataISO) {
        if (!dataISO) return "";
        const [ano, mes, dia] = dataISO.split("-");
        return `${dia}/${mes}/${ano}`;
    }

    useEffect(() => {
        if (!user || !user.faturas) return;

        // Supondo que user.faturas seja um objeto com arrays agrupados ou um array com todas faturas
        // Se for um array só com todas faturas, descomente a próxima linha e comente as outras:
        // const todasFaturas = user.faturas;

        // Exemplo: se você armazenar agrupado, combine arrays:
        const todasFaturas = [
            ...(user.faturas.pagas || []),
        ];

        const faturasFormatadas = todasFaturas.map((fatura, index) => {
            const statusInfo = statusMap[fatura.status] || { label: fatura.status, colorBg: "#eee", colorText: "#333" };

            return {
                id: index + 1,
                numero: fatura.nossoNumero || `FAT-${index + 1}`,
                vencimento: formatarDataBR(fatura.dueDate) || "—",
                valor: fatura.value || 0,
                status: statusInfo.label,
                bankSlipUrl: fatura.bankSlipUrl || "#",
                paymentDate: fatura.paymentDate ? formatarDataBR(fatura.paymentDate) : "—",
                billingType: fatura.billingType || "—",
                colorBg: statusInfo.colorBg,
                invoiceUrl: fatura.invoiceUrl || "#",
                colorText: statusInfo.colorText,
            };
        });

        setFaturas(faturasFormatadas);
    }, [user]);

    const linhasFiltradas = useMemo(() => {
        return faturas
            .filter(f => statusFiltro === "todos" || f.status === statusFiltro)
            .filter(f => f.numero?.toLowerCase().includes(busca.toLowerCase()));
    }, [faturas, statusFiltro, busca]);


    const formatarData = (data) => {
        return new Intl.DateTimeFormat("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            timeZone: "UTC",
        }).format(new Date(data));
    };


    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <div style={{ padding: "30px", background: "#f4f6f8", minHeight: "100vh", marginTop: "64px" }}>
                <div style={{ width: "100%", height: "fit-content", padding: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
                        <div style={{ width: "80%" }}>
                            <Breadcrumbs aria-label="breadcrumb">
                                <Link
                                    underline="hover"
                                    sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                                    color="inherit"
                                    onClick={() => navigate("../Dashboard")}
                                >
                                    <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Dashboard
                                </Link>
                                <Typography
                                    sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                                >
                                    <HourglassBottomIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Faturas Pagas
                                </Typography>
                            </Breadcrumbs>
                        </div>
                    </div>
                </div>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Box sx={{ width: { xs: "90%", md: "80%" }, borderRadius: "8px" }}>
                        <Typography
                            variant="h4"
                            sx={{ fontWeight: 700, mb: 3 }}
                        >
                            Histórico de Faturas
                        </Typography>
                    </Box>
                </Box>
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <div style={{ width: window.innerWidth > 768 ? "80%" : "100%", display: "flex", justifyContent: "flex-start", marginBottom: "10px", gap: 10, flexWrap: "wrap" }}>
                        <div style={{ width: window.innerWidth > 768 ? "280px" : "100%", height: "150px", backgroundColor: "#fff", borderRadius: "8px", display: "flex", flexDirection: "column", justifyContent: "space-between", gap: 2, padding: "20px", borderLeft: "4px solid #2e7d32" }}>
                            <span style={{ display: "flex", flexDirection: "column", gap: 1, fontSize: "12px", fontWeight: 500 }}>
                                ÚLTIMA FATURA
                            </span>
                            <span style={{ fontSize: "34px", fontWeight: 700, color: "#2e7d32" }}>
                                R$ {user?.faturas?.pagas[user?.faturas?.pagas.length - 1] ? user?.faturas?.pagas[user?.faturas?.pagas.length - 1].value.toFixed(2).replace(".", ",") : "..."}
                            </span>
                            <span style={{ display: "flex", alignItems: "center", gap: 1, fontSize: "12px", fontWeight: 500 }}>
                                <CalendarMonthIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Pago em {user?.faturas?.pagas[user?.faturas?.pagas.length - 1] ? formatarData(user.faturas.pagas[user.faturas.pagas.length - 1].paymentDate) : "..."}
                            </span>
                        </div>
                        <div style={{ width: window.innerWidth > 768 ? "280px" : "100%", height: "150px", backgroundColor: "#000", color: "#fff", borderRadius: "8px", display: "flex", flexDirection: "column", justifyContent: "space-between", gap: 2, padding: "20px" }}>
                            <span style={{ display: "flex", flexDirection: "column", gap: 1, fontSize: "12px", fontWeight: 500 }}>
                                STATUS DA ASSINATURA
                            </span>
                            <span style={{ fontSize: "34px", fontWeight: 700, color: "#1EFF86", display: "flex", alignItems: "center", gap: 15 }}>
                                {user?.plano?.nome ? user.plano.nome : "..."} <span style={{ backgroundColor: "#1EFF86", color: "#000", padding: "5px 10px", borderRadius: "15px", fontSize: "12px", fontWeight: 500 }}>ATIVO</span>
                            </span>
                            <span style={{ display: "flex", alignItems: "center", gap: 1, fontSize: "12px", fontWeight: 500 }}>
                                <CachedIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Próximo pagamento: {user?.assinatura?.proximaCobranca ? formatarData(user.assinatura.proximaCobranca) : "..."}
                            </span>
                        </div>
                    </div>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <div style={{ width: window.innerWidth > 768 ? "80%" : "100%", display: "flex", justifyContent: "space-between", gap: 15, flexWrap: "wrap" }}>
                        <div style={{ width: "100%", minWidth: window.innerWidth > 768 ? "280px" : "100%" }}>
                            <TableContainer component={Paper} sx={{ borderRadius: "12px" }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><strong>Nº Fatura</strong></TableCell>
                                            <TableCell><strong>Plano</strong></TableCell>
                                            <TableCell><strong>Data de pagamento</strong></TableCell>
                                            <TableCell><strong>Valor</strong></TableCell>
                                            <TableCell><strong>Método</strong></TableCell>
                                            <TableCell><strong>Status</strong></TableCell>
                                            <TableCell align="center"><strong>Ação</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {linhasFiltradas.length > 0 ? (
                                            linhasFiltradas.map((fatura) => (
                                                <TableRow key={fatura.id}>
                                                    <TableCell>{fatura.numero}</TableCell>
                                                    <TableCell>{user?.plano?.nome ? user.plano.nome : "..."}</TableCell>
                                                    <TableCell>{fatura.paymentDate}</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>
                                                        R$ {Number(fatura.valor).toFixed(2).replace(".", ",")}
                                                    </TableCell>
                                                    <TableCell>{fatura.billingType}</TableCell>
                                                    <TableCell>
                                                        <span
                                                            style={{
                                                                padding: "4px 10px",
                                                                borderRadius: "12px",
                                                                backgroundColor: fatura.colorBg,
                                                                color: fatura.colorText,
                                                                fontWeight: 600,
                                                                fontSize: "0.8rem"
                                                            }}
                                                        >
                                                            {fatura.status.toUpperCase()}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => window.open(fatura.invoiceUrl, "_blank")}
                                                            disabled={[
                                                                "Reembolsada",
                                                                "Reembolso solicitado",
                                                                "Reembolso em progresso",
                                                                "Chargeback",
                                                                "Análise de risco"
                                                            ].includes(fatura.status)}
                                                            sx={{
                                                                backgroundColor: "#1EFF86",
                                                                color: "black",
                                                                width: 32,
                                                                height: 32,
                                                                '&:hover': {
                                                                    backgroundColor: "#1EBF5C",
                                                                },
                                                                '&.Mui-disabled': {
                                                                    backgroundColor: "#E0E0E0",
                                                                    color: "#9E9E9E",
                                                                }
                                                            }}
                                                        >
                                                            <DownloadIcon fontSize="small" />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={6} align="center">
                                                    Nenhuma fatura encontrada.
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </div>
            </div>
            <ModalNotificacao
                openModalNotificacao={openModalNotificacao}
                onClose={() => setOpenModalNotificacao(false)}
                notificacoes={notificacoes}
            />
        </>
    );
};

export default FaturasPagas;
